import React, { useRef, useEffect, useState } from "react";
import { Range, getTrackBackground } from "react-range";

import upgrade from "assets/images/upgrade.svg";

const ProgressBar = ({ progressValue, keyword, userValue, setUserValue }) => {
  const progressRef = useRef(null);
  const userBarRef = useRef(null);
  const userRef = useRef(null);
  const indicatorRef = useRef(null);
  const progressValueRef = useRef(null);
  const containerRef = useRef(null);
  const extrabarRef = useRef(null);

  const [previous, setPrevious] = useState(false);

  useEffect(() => {
    if (progressValue == 0) return;
    progressRef.current.style.width = parseInt(progressValue) + "%";
    indicatorRef.current.style.left = parseInt(progressValue) + "%";
    progressValueRef.current.style.left = parseInt(progressValue) - 1 + "%";
    if (parseInt(progressValue) !== 100) {
      extrabarRef.current.style.left = parseInt(progressValue) + 3.4 + "%";
      userBarRef.current.style.left = parseInt(progressValue) + 6.2 + "%";
      userBarRef.current.style.width = 100 - parseInt(progressValue) + "%";
    } else if (parseInt(progressValue) === 100) {
      extrabarRef.current.style.display = "none";
    }
  }, []);

  useEffect(() => {
    let cssUnit = "%";

    userRef.current.style.left =
      parseInt(progressValue) + parseInt(userValue[keyword][0]) + 5 + cssUnit;

    if (userValue[keyword][0] <= 0) {
      userRef.current.style.display = "none";
    } else if (userValue[keyword][0] >= 1) {
      userRef.current.style.display = "block";
    }
  }, [userValue]);

  const handleValueChange = (value) => {
    if (value < 2) {
      setPrevious(true);
    } else if (value != 100) {
      setPrevious(false);
    }

    if (previous) {
      setUserValue((prev) => {
        const skill = `${keyword}`;

        return {
          ...prev,
          [skill]: [0],
        };
      });
    } else {
      setUserValue((prev) => {
        const skill = `${keyword}`;

        return {
          ...prev,
          [skill]: value,
        };
      });
    }
  };

  return (
    <div className="skill-bar mx-md-2 mt-1">
      <div className="line-bar position-relative" ref={containerRef}>
        <span className="user-value" ref={userRef}>
          {parseInt(userValue[keyword][0])}
        </span>
        <div class="progress">
          <div
            class="progress-bar"
            role="progressbar"
            aria-valuenow="50"
            aria-valuemin="0"
            aria-valuemax="100"
            ref={progressRef}
          >
            <span className="indicator" ref={indicatorRef} />
            <span className="extra-user-select" ref={extrabarRef} />
            <span className="progress-value" ref={progressValueRef}>
              {parseInt(progressValue)}
            </span>
            {parseInt(progressValue) !== 100 ? (
              <div className="user-bar" ref={userBarRef}>
                <Range
                  values={userValue[keyword]}
                  step={1}
                  min={0}
                  max={100 - parseInt(progressValue)}
                  onChange={handleValueChange}
                  renderTrack={({ props, children }) => (
                    <div
                      onMouseDown={props.onMouseDown}
                      onTouchStart={props.onTouchStart}
                      style={{
                        ...props.style,
                      }}
                      className="w-100 d-flex"
                    >
                      <div
                        ref={props.ref}
                        style={{
                          background: getTrackBackground({
                            values: userValue[keyword],
                            colors: ["#068385", "#eeeeee"],
                            min: 0,
                            max: 100 - parseInt(progressValue),
                          }),
                        }}
                        className="w-100 align-self-center track"
                      >
                        {children}
                      </div>
                    </div>
                  )}
                  renderThumb={({ props, isDragged }) => (
                    <div
                      {...props}
                      isDragged
                      style={{
                        height: "1em",
                        width: "1em",
                        background: "#068385",
                      }}
                      className="d-flex justify-content-center rounded-circle position-absolute align-items-center mb-0 thumb"
                    >
                      {/* <img src={upgrade} alt="upgrade" /> */}
                    </div>
                  )}
                />
              </div>
            ) : (
              ""
            )}
          </div>
          <span
            className={`full-value ${
              84 - parseInt(progressValue) <= userValue[keyword][0] && "d-none"
            }`}
          >
            100
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
